import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const SessionRecordingConfig = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/session-recording',
            component: FuseLoadable({
                loader: () => import('./SessionRecordingApp'),
            }),
        },
    ],
};

export default SessionRecordingConfig;
